import { ReferralNavigationCard } from '@features/wellbeing-referrals/components/ReferralNavigationCard'
import { SimpleGrid, Stack, Text, Title } from '@mantine/core'
import { IconClock, IconHeartHandshake, IconUserPlus } from '@tabler/icons-react'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/referrals/')({ component: ReferralsIndex })

function ReferralsIndex() {
  return (
    <Stack p="lg" gap="lg" maw={1000} mx="auto" w="100%">
      <Stack gap={3}>
        <Title order={2}>Referrals</Title>
        <Text c="dimmed">Choose a referral service.</Text>
      </Stack>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
        <ReferralNavigationCard title="Health & Wellbeing" description="Health, wellbeing and safeguarding referrals." icon={IconHeartHandshake} to="/referrals/wellbeing" />
        <ReferralNavigationCard title="Study Support" description="Learning and study support referrals." icon={IconUserPlus} to="/referrals/study-support" />
        <ReferralNavigationCard title="Exam Access Arrangements" description="Exam access arrangement referrals." icon={IconClock} to="/referrals/exam-access-arrangements" />
      </SimpleGrid>
    </Stack>
  )
}
